import { axClient } from "../../../secured/mixins/axios-mixins";
import { vgrmApp } from "@/secured/clients/vgrm";
import "@/secured/components/activation-code-form";

vgrmApp.createApp({
  data: {
    abos: [],
    aboClass: "col-md-4",
    relatedArticles: [],
    companies: [],
    mainRubric: null
  },
  mounted: function() {
    let vm = this;
    let articleElement = document.querySelector("div[data-main-article]")
    if (articleElement) {
      let articleId = articleElement.getAttribute("data-main-article")
      let rubricId = articleElement.getAttribute("data-main-rubric")
      if (rubricId) {
        axClient.apiGet("/article/related?article=" +articleId +"&rubric=" +rubricId, function(resp) {
          if (resp.data?.result) {
            vm.relatedArticles.push(...resp.data.result)
          } else {
            vm.relatedArticles.push(...resp.data)
          }
        })
      }
    }
    axClient.apiGet("/product/abos", function(resp) {
      vm.abos.push(...resp?.data?.result)
      if (vm.abos.length == 2 || vm.abos.length >= 4) {
        vm.aboClass = "col-md-6"
      }
    })
  }
})